import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {
    CheckIcon,
    ThinFilterIcon,
    ThinNotAllowedIcon,
    ThinTimeIcon,
    ThinTrashIcon
} from "../../../components/icons/material-icons";
import {ChooseModal} from "../../../components/template/choose-modal";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {Link} from "react-router-dom";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {RemoveModal} from "../../../components/template/remove-modal";

interface requestInterface{
    id:number,
    staffId:number,
    name:string,
    category:string,
    title:string
    isAnswered:boolean,
    answeredAt:string,
    createdAt:string,
    isApproved:boolean,
}

export const AdminsStaffRequestsScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [status, setStatus] = useState('pending' as 'pending' | 'all' | 'answered');
    const [list,setList] = useState<requestInterface[]>([]);
    const fetchList = (s:string) => {
        PostJSON(
            Apis.server + '/core/admins/staff/requests/list',
            {
                status: s,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list:requestInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchList('pending');
        document.title = 'درخواست ها | منابع انسانی | اتوماسیون';
    }, []);
    const [filterModal, setFilterModal] = useState(false);
    const [removeModal,setRemoveModal] = useState({
        show:false,
        id:0,
        title:'',
    });
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/requests', title: 'درخواست ها'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>درخواست ها</b>
                                <button onClick={() => setFilterModal(true)}>
                                    <ThinFilterIcon/>
                                    <span>{status === 'answered' ? 'پاسخ داده شده' : (status === 'pending' ? 'در انتظار' : 'نمایش همه')}</span>
                                </button>
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>عنوان</th>
                                    <th>همکار</th>
                                    <th>وضعیت</th>
                                    <th>تاریخ ثبت</th>
                                    <th>تاریخ پاسخ</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s,i)=>
                                        <tr key={"J28SjxtW__xh27SS"+i}>
                                            <td>{StringDigitsConvertToPersian(i+1)}</td>
                                            <td>
                                                <Link to={`view/${s.id}`}>
                                                    {s.title}
                                                </Link>
                                            </td>
                                            <td>
                                                <Link to={`/admins/staff/view/${s.staffId}`}>
                                                    {s.name}
                                                </Link>
                                            </td>
                                            <td>
                                                <em data-color={s.isAnswered ? (s.isApproved ? 'green':'red') : ''}>
                                                    {s.isAnswered ? (s.isApproved ? <CheckIcon/>:<ThinNotAllowedIcon/>) : <ThinTimeIcon/>}
                                                    {s.isAnswered ? (s.isApproved ? 'تایید شده':'رد شده') : 'در انتظار'}
                                                </em>
                                            </td>
                                            <td>{StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>{s.isAnswered ? (StringDigitsConvertToPersian(s.answeredAt.split(' ')[1] + " " + GregorianToPersian(s.answeredAt.split(' ')[0]).replaceAll('-', '/'))) : '-'}</td>
                                            <td>
                                                <button className="open-tooltip" onClick={()=>setRemoveModal({
                                                    title: s.title,
                                                    show: true,
                                                    id: s.id,
                                                })}>
                                                    <i>حذف</i>
                                                    <ThinTrashIcon/>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <ChooseModal
                active={filterModal}
                closeHandler={() => setFilterModal(false)}
                onDone={(s: 'all' | 'pending' | 'answered') => {
                    setStatus(s);
                    ShowProgressLoading();
                    fetchList(s);
                }}
                options={[
                    {key: 'all', value: 'نمایش همه موارد'},
                    {key: 'pending', value: 'تنها درخواست های در انتظار'},
                    {key: 'answered', value: 'تنها درخواست های پاسخ داده شده'},
                ]}
                currentKey={status}
                title={"فیلتر نمایش درخواست ها"}
                question={"کدام درخواست ها نمایش داده شود؟"}
                submitText={"اعمال فیلتر"}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف درخواست"}
                desc={`آیا مطمئن هستید می‌خواهید ${removeModal.title} را حذف کنید؟`}
                onRemove={() => {
                    const s = status;
                    ShowProgressLoading();
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/requests/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'درخواست حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList(s);
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};